export const getCustomerList = ({ state }) => state.corporate.customerList;
export const getSalesOfficerList = ({ state }) => state.corporate.salesOfficerList;
export const getCorporateReport = ({ state }) => state.corporate.corporateReport;
export const getCustomerCorporateReport = ({ state }) => state.corporate.customerCorporateReport;
